// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3_lHe","content":"styles_content__1o9Y0"};